import {connect} from 'react-redux';
import {Graphics as Component} from './Graphics';
import {
  setVol,
  setVolume,
  toggleShowVolumeModal,
  removeTip,
  onFirstStopper,
  togglePlungerTooltip,
  onSecondStopper,
  onMix,

} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {
  return {
    id: ownProps.id,
    hasTip: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].tipAttached,
    showVolumeModal: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].showVolumeModal,
    contactElement: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].contactElement,
    plungerPosition: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].plungerPosition,
    animatingOut: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].animatingOut,
    currentPlungerPos: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].currentPlungerPos,
    solution: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].solution,
    solutionAlias: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].solutionAlias,
    type: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].type,
    maxVol: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].maxVol,
    volume: state.notebook.protocolSection.scene.apparatus.pipettes[ownProps.id-1].volume,
    notebookExpanded: !state.notebook.notebookCollapsed
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPipette: (data) => {
      dispatch(createPipette(data))
    },
    setVol: (data) => {
      dispatch(setVol(data))
    },
    setVolume: (data) => {
      dispatch(setVolume(data))
    },
    toggleShowVolumeModal: (data) => {
      dispatch(toggleShowVolumeModal(data))
    },
    removeTip: (data) => {
      dispatch(removeTip(data))
    },
    onFirstStopper: (data) => {
      dispatch(onFirstStopper(data))
    },
    togglePlungerTooltip: (data) => {
      dispatch(togglePlungerTooltip(data))
    },
    onSecondStopper: (data) => {
      dispatch(onSecondStopper(data))
    },
    onMix: (data) => {
      dispatch(onMix(data))
    },
  };
}

export const Graphics = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
